module.exports = __webpack_public_path__ + "img/ico_badge_task.f0b65189.svg";